export const SET_BROWSER_ONLINE = "SET_BROWSER_ONLINE";
export const SET_SOCKET_STATUS = "SET_SOCKET_STATUS";
export const SET_SOCKET_RECONNECT_ATTEMPT = "SET_SOCKET_RECONNECT_ATTEMPT";
export const RESET_NETWORK_STATE = "RESET_NETWORK_STATE";
